/**
 * LRU Cache Implementation
 */ export class LRUCache {
    get(k) {
        // If the key exists in the cache, remove it and then put it on top.
        // This makes it the most recently used item.
        const item = this.cache.get(k);
        if (item) {
            this.cache.delete(k);
            this.cache.set(k, item);
        }
        return item;
    }
    set(k, v) {
        if (this.cache.has(k)) {
            // If the key already exists in the cache, remove it.
            this.cache.delete(k);
        } else if (this.cache.size >= this.max) {
            // If the cache is full, remove the first item, which is the least recently used.
            const firstKey = this.cache.keys().next().value;
            this.cache.delete(firstKey);
        }
        // Add the new item to the top of the cache.
        this.cache.set(k, v);
    }
    dump() {
        return Array.from(this.cache.entries()).map(([k, v])=>({
                k,
                v
            }));
    }
    keys() {
        return Array.from(this.cache.keys());
    }
    load(dump) {
        this.cache.clear();
        dump.forEach(({ k, v })=>{
            this.set(k, v);
        });
    }
    delete(k) {
        return this.cache.delete(k);
    }
    constructor(max){
        this.cache = new Map();
        if (max <= 0) {
            throw new Error("Max should be a positive number");
        }
        this.max = max;
    }
}
